import makeApiRequest from '@/services/makeApiRequest';

// eslint-disable-next-line import/prefer-default-export
export const requests = {
  getEntityItems: async ({ key }) => (makeApiRequest('/api/entity', 'POST', { key })),
  getOffersFacets: async (aggregates, filter) => (makeApiRequest('/api/offers/facets', 'POST', { aggregates, filter })),
  // getOffers: async ({ limit, start, filter, query, participantsFilter }) => {
  //   const params = [];

  //   if (limit) params.push(`limit=${limit}`);
  //   if (start) params.push(`start=${start}`);
  //   if (filter) params.push(`filter=${JSON.stringify(filter)}`);
  //   if (query) params.push(`query=${encodeURIComponent(query)}`);
  //   if (participantsFilter) params.push(`participantsFilter=${JSON.stringify(participantsFilter)}`);

  //   return makeApiRequest(`/api/offers?${params.join('&')}`, 'GET');
  // },
  getAppLoad: async () => makeApiRequest('/api/appLoad', 'GET'),

  getOffer: async (uuid, url, id) => {
    const params = [];

    if (uuid) params.push(`uuid=${uuid}`);
    if (url) params.push(`url=${url}`);
    if (id) params.push(`id=${id}`);

    return makeApiRequest(`/api/offer?${params.join('&')}`, 'GET');
  },
  createOffer: async ({ input }) => makeApiRequest('/api/offer', 'POST', { type: 'create', input }),
  saveOffer: async ({ input, isEditMode, mutationName }) => makeApiRequest('/api/offer', isEditMode ? 'PUT' : 'POST', { mutationName, input }),
  deleteOffer: async uuid => makeApiRequest('/api/offer', 'DELETE', { type: 'offer', uuid }),
  duplicateOffer: async ({ uuid, workspace }) => makeApiRequest('/api/offer', 'POST', { type: 'duplicate', input: { uuid, workspace } }),
  generateOfferLLmData: async ({ uuid }) => makeApiRequest('/api/offer', 'POST', { type: 'getLLMData', input: { uuid } }),
  diffuseOffer: async ({ uuid, username }) => {
    const response = await makeApiRequest('/api/offer', 'POST', { type: 'diffuse', input: { uuid, username } });

    if (!response?.success) {
      throw new Error(response?.message || 'Failed to diffuse offer');
    }

    return response;
  },
  dispatchOffer: async ({ uuid, entities, status }) => makeApiRequest('/api/offer', 'POST', { type: 'dispatchOffer', input: { uuid, entities, status } }),
  getModelOffer: async uuid => makeApiRequest(`/api/model-offer?uuid=${uuid}`, 'GET'),
  saveModelOffer: async ({ offerUuid, input, isEditMode, mutationName }) => makeApiRequest('/api/model-offer', isEditMode ? 'PUT' : 'POST', { mutationName, offerUuid, input }),
  deleteModelOffer: async uuid => makeApiRequest('/api/model-offer', 'DELETE', { uuid }),

  getJob: async (uuid, url, id) => {
    const params = [];

    if (uuid) params.push(`uuid=${uuid}`);
    if (url) params.push(`url=${url}`);
    if (id) params.push(`id=${id}`);

    return makeApiRequest(`/api/job?${params.join('&')}`, 'GET');
  },
  saveJob: async ({ input, isEditMode, mutationName }) => makeApiRequest('/api/job', isEditMode ? 'PUT' : 'POST', { mutationName, input }),
  deleteJob: async uuid => makeApiRequest('/api/job', 'DELETE', { uuid }),

  getApplication: uuid => {
    if (!uuid) return null;

    return makeApiRequest(`/api/application?uuid=${uuid}`, 'GET');
  },

  getCollaboratorApplications: filter => {
    const encodedFilter = encodeURIComponent(JSON.stringify(filter));

    return makeApiRequest(`/api/application/collaborator-applications?filter=${encodedFilter}`, 'GET');
  },

  closeApplications: async offerUuid => makeApiRequest('/api/application/collaborator-close-applications', 'PUT', { offerUuid }),

  updateRelatedApplications: async application => makeApiRequest('/api/application/collaborator-update-related-applications', 'PUT', { application }),

  saveApplication: async ({ input, isEditMode, mutationName }) => makeApiRequest('/api/application', isEditMode ? 'PUT' : 'POST', { mutationName, input }),

  getCollaborator: () => (makeApiRequest('/api/collaborator', 'GET')),

  getProspect: uuid => {
    if (!uuid) return null;

    return makeApiRequest(`/api/prospect?uuid=${uuid}`, 'GET');
  },

  updateProspect: async ({ input, isEditMode, mutationName }) => makeApiRequest('/api/prospect', isEditMode ? 'PUT' : 'POST', { mutationName, input }),

  getBroadBeanNewUrl: async (broadBeanUuid, offerUUID, broadBeanUsername) => {
    try {
      // Validate inputs
      // Validate input
      if (!offerUUID) {
        throw new Error('Offer UUID is required');
      }

      // If no broadBeanUuid, create new diffusion
      if (!broadBeanUuid) {
        const diffuseResponse = await requests.diffuseOffer({ uuid: offerUUID, username: broadBeanUsername });
        return diffuseResponse.data?.url || null;
      }

      // Check existing broadbean status
      const statusResponse = await makeApiRequest(
        `/api/broadbean?reference=${broadBeanUuid}`,
        'GET'
      );

      // If status check fails, try new diffusion
      if (!statusResponse.success) {
        const diffuseResponse = await requests.diffuseOffer({ uuid: offerUUID, username: broadBeanUsername });
        return diffuseResponse.data?.url || null;
      }

      // Create new broadbean
      const { data } = await makeApiRequest(
        '/api/broadbean',
        'POST',
        {
          reference: broadBeanUuid,
          username: broadBeanUsername
        }
      );

      return data?.url || null;
    } catch (error) {
      console.error('Error in getBroadBeanNewUrl:', error);
      throw error;
    }
  },

  async downloadAttachment (downloadUrl) {
    return makeApiRequest(`/api/attachment?path=${downloadUrl}`);
  },

  generateOfferPDF: async data => makeApiRequest('/api/generate-offer-pdf', 'POST', data),

  async uploadAttachment (files, collaboratorUuid) {
    const data = new FormData();
    if (files && files.length) {
      for (const file of files) {
        data.append('files', file, file.name);
      }
    }
    data.append('collaboratorUuid', collaboratorUuid);
    return makeApiRequest('/api/attachment', 'PUT', data, null, true);
  },

  // SEARCH REQUEST
  searchOpenSearchContent: async ({ workspace, wtype, online, status, filtersConfiguration = [], activeFilters = [], query, from = 0, size = 1000, sort, collapse, indice, persistedFilters = [], signal, offersUuidFilter }) => makeApiRequest('/api/search', 'POST', { workspace, wtype, online, status, filtersConfiguration, activeFilters, query, from, size, indice, persistedFilters, sort, collapse, offersUuidFilter }, signal),

  searchOpenSearchStatistics: async ({ signal, key, entityUuid }) => makeApiRequest('/api/searchOS', 'POST', { key, entityUuid }, signal)
};
